import { render, staticRenderFns } from "./DetailsInfo.vue?vue&type=template&id=c91ce3d4&scoped=true"
import script from "./DetailsInfo.vue?vue&type=script&lang=js"
export * from "./DetailsInfo.vue?vue&type=script&lang=js"
import style0 from "./DetailsInfo.vue?vue&type=style&index=0&id=c91ce3d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91ce3d4",
  null
  
)

export default component.exports